import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useReferentialSchedulingStates } from "@/entities/referential/referential-scheduling-states";

export const useSchedulingStatesFilter = () => {
  const { t } = useTranslation();
  const { schedulingStates } = useReferentialSchedulingStates();

  const filters = useMemo(
    () =>
      schedulingStates
        .filter((state) => state.value !== 0)
        .map((state) => ({
          text: t(`indicator:schedulingIssue:${state.value}`, {
            defaultValue: state.description,
          }),
          value: state.value,
        })),
    [schedulingStates]
  );

  return {
    filterMode: "tree",
    filters,
  };
};
